export const WEBHOOK_EVENT_TYPES = {
  CONVERSION: 'conversion',
  // Add other event types as needed
};
